import React from 'react';
import './App.css';
import DietAssistant from './components/DietAssistant';

function App() {
  return (
    <div className="App">
      <DietAssistant />
    </div>
  );
}

export default App;